let productPdfs;
try {
  productPdfs = require.context('./product-images', false, /\.pdf$/);
} catch (e) {
  productPdfs = null;
}

export function getProductPdf(name) {
  if (!productPdfs) return null;
  try {
    return productPdfs(`./${name}.pdf`);
  } catch (e) {
    return null;
  }
}
